import React from "react";

import { Statistics } from "src/components/common";
import { useBody } from "./hooks";

export const Body = () => {
  const { getBodyProps, values } = useBody();
  return (
    <div {...getBodyProps()}>
      <div className={values.styles.wrapper}>
        <Statistics />
      </div>
    </div>
  );
};
